// extracted by mini-css-extract-plugin
export default {"default":"Ygd2AnI8","opened":"sSprZlkY","closed":"mpby8nYT"};